import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@hooks';
import '../styles/landing.css';
import {
  LandingNavbar,
  HeroSection,
  TickerSection,
  ValueGrid,
  PricingSection,
  LandingFooter,
} from '@components/landing';

export default function Landing() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return null;
  }

  return (
    <div className="min-h-screen bg-soft-paper font-body">
      <LandingNavbar />
      <HeroSection />
      <TickerSection />
      <ValueGrid />
      <PricingSection />
      <LandingFooter />
    </div>
  );
}
